<template>
  <div id="app">
    <entry-sidebar v-model="entrySidebarModel" />
    <dt-report-sidebar></dt-report-sidebar>
    <group-comment-sidebar />
    <agreement-sidebar />
    <general-statistics-filter-sidebar />
    <holiday-sidebar />
    <salary-rate-sidebar />
    <salary-type-filter-sidebar />
    <div class="app-viewport">
      <app-header v-if="currentUser.name"></app-header>

      <div class="app-contents">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppHeader from "./components/AppHeader.vue";
import EntrySidebar from "./components/sidebar/EntrySidebar.vue";
import GroupCommentSidebar from "./components/sidebar/GroupCommentSidebar.vue";
import AgreementSidebar from "./components/sidebar/AgreementSidebar.vue";
import GeneralStatisticsFilterSidebar from "./components/sidebar/GeneralStatisticsFilterSidebar.vue";
import HolidaySidebar from "./components/sidebar/HolidaySidebar.vue";
import DtReportSidebar from "./components/sidebar/DtReportSidebar.vue";
import SalaryRateSidebar from "./components/sidebar/SalaryRateSidebar.vue";
import SalaryTypeFilterSidebar from "./components/sidebar/SalaryTypeFilterSidebar.vue";

export default {
  name: "app",
  components: {
    AppHeader,
    EntrySidebar,
    GroupCommentSidebar,
    AgreementSidebar,
    GeneralStatisticsFilterSidebar,
    HolidaySidebar,
    DtReportSidebar,
    SalaryRateSidebar,
    SalaryTypeFilterSidebar
  },
  computed: {
    ...mapGetters("entrySidebar", ["entrySidebarModel"]),
    ...mapGetters(["currentUser"]),
  },
  methods: {
    ...mapActions("entrySidebar", [
      "entrySidebarUpdate",
      "entrySidebarDelete",
      "entrySidebarCancel",
    ]),
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  background-color: $background;
}
html {
  overflow: hidden !important;
}

#app {
  font-family: Lato, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $textcolor;
  height: 100vh;
  display: flex;

  .app-viewport {
    flex: 1;
    display: flex;
    flex-flow: column;

    .app-header {
      flex: 0;
    }
    .app-contents {
      flex: 2;
      overflow-y: scroll;
      width: 100%;
      // padding: 2em;
    }
  }
}
</style>
